<template>
  <div>
    <no-ssr>
      <message-toast-wrapper />
      <system-menu v-if="loggedIn" />
      <progress-loader />
      <media-manager v-if="loggedIn" />
      <AModal
        v-model="loginModalVisible"
        size="sm"
      >
        <login-subform
          :show-create-account="true"
          @loginInProgress="hideLoginModal"
          @toggle="hideLoginModal"
        />
      </AModal>
      <AModal
        v-model="onRequestModalVisible"
        size="sm"
      >
        <form-renderer
          v-if="formItem.form"
          :form="formItem"
          @success="formSubmissionSucceed"
          @failure="formSubmissionFailed"
        />
        <template v-else>
          {{noFormMessage}}
        </template>
      </AModal>
    </no-ssr>
  </div>
</template>

<script>

import applogger from '@applogger'

export default {
  name: 'below-the-fold',
  components: {
    'form-renderer': () => import('dev/vuejs-forms/src/components/FormRenderer')
  },
  data: function() {
    return {
      loginModalVisible: false,
      formItem: {
        form: null,
        actions: null
      },
      cartRequestPopup: {
        popupMode: null,
        node: {},
        message: ''
      }
    }
  },
  created() {
    // login
    this.$eventHub.$on('showLoginModal', this.showLoginModal)
    this.$eventHub.$on('hideLoginModal', this.hideLoginModal)
    this.$eventHub.$on('productRequestAdd', this.handleProductRequestAdd)
  },
  computed: {
    noFormMessage() {
      return this.$store.state.registry.getSiteSetting('wishlistFormDefaultMessage')
    },
    loggedIn() {
      return this.$store.getters['user/isLoggedIn']
    },
    onRequestModalVisible: {
      get: function() {
        return !!this.cartRequestPopup.node.title
      },
      set: function(v) {
        if (!v) {
          this.cartRequestPopup = {
            popupMode: null,
            node: {},
            message: ''
          }
        }
      }
    }
  },
  methods: {
    handleProductRequestAdd(payload) {
      const formID = payload.node.wishlist ? payload.node.wishlist : payload.node.wishlistform
      if (!formID || formID === '0') {
        this.cartRequestPopup = payload
        return
      }

      const formEndpointUrl = this.$store.getters.getServiceEndpoint('circumspectis') + `/api/v1/form/${formID}`
      const siteID = this.$store.getters.getSiteId
      this.$eventHub.$emit('showProgressLoader')
      fetch(formEndpointUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Site-ID': siteID
        }
      })
        .then(resp => {
          if (resp.ok) {
            return resp.json()
              .then(data => {
                this.formItem = {
                  formid: formID,
                  ...data.formdata
                }
                this.cartRequestPopup = payload
                this.$eventHub.$emit('hideProgressLoader')
              })
          }
          this.$eventHub.$emit('hideProgressLoader')
          throw new Error(`Could not load form data for ID: ${formID} - ${resp.status} - ${resp.statusText}`)
        })
        .catch(err => {
          this.$eventHub.$emit('hideProgressLoader')
          applogger.error(err)
        })
    },
    hideLoginModal() {
      this.loginModalVisible = false
    },
    showLoginModal() {
      this.loginModalVisible = true
    },
    formSubmissionSucceed: function(results) {
      this.cartRequestPopup = {
        popupMode: null,
        node: {},
        message: ''
      }
      results.forEach(msg => {
        const statusMessage = {
          type: (msg.status === undefined) ? 'info' : (msg.status) ? 'success' : 'error',
          title: msg.title || 'Form Submission Successful',
          text: msg.text,
          notification: false,
          showClose: true,
          timeout: 6000
        }
        this.$eventHub.$emit('statusMessage', statusMessage)
      })
    },
    formSubmissionFailed: function(results) {
      this.cartRequestPopup = {
        popupMode: null,
        node: {},
        message: ''
      }
      const statusMessage = {
        type: 'error',
        title: 'Form Submission Unsuccessful',
        text: results.message,
        notification: false,
        showClose: true,
        timeout: 6000
      }
      this.$eventHub.$emit('statusMessage', statusMessage)
    }
  }
}
</script>

<style>

</style>
